// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img.video-component--TFrZU{position:absolute;width:100%;height:100%;-o-object-fit:contain;object-fit:contain}video.hide-mute--snVw1::-webkit-media-controls-volume-slider{display:none}video.hide-mute--snVw1::-webkit-media-controls-mute-button{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-component": "video-component--TFrZU",
	"hide-mute": "hide-mute--snVw1"
};
export default ___CSS_LOADER_EXPORT___;
